import lottie from 'lottie-web';
import vars from '../helpers';
function loadLottie() {
	let lottieElement = vars.$document.find('.lottie');

	lottieElement.each((i, item) => {
		const anim = lottie.loadAnimation({
			container: item,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: $(item).attr('data-url'),
		});

		anim.addEventListener('data_ready', (event, image) => {
			vars.$document.trigger('lottie-load', 10000);
		});

		const lottieContainer = $(item).closest('.lottie-animate');
		let directionMenu = 1;
		if (vars.$html.hasClass('has-hover')) {

			lottieContainer.on('mouseenter', () => {
				if (anim.isLoaded) {
					anim.setDirection(directionMenu);
					anim.play();
				}
			}).on('mouseleave', () => {
				if (anim.isLoaded) {
					anim.setDirection(-directionMenu);
					anim.play();
				}
			});
		}
	});
}
function init() {
	loadLottie();
}

export default {
	init,
};
